"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconGastronomyThematic = void 0;
var React = __importStar(require("react"));
var IconGastronomyThematic = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M13.6582,9.0254 C13.7902,9.0694 16.9072,10.1414 17.9742,13.3414 C18.0612,13.6034 17.9202,13.8864 17.6582,13.9744 C17.6052,13.9924 17.5532,14.0004 17.5002,14.0004 C17.2912,14.0004 17.0962,13.8674 17.0252,13.6584 C16.1152,10.9264 13.3692,9.9834 13.3422,9.9744 C13.0802,9.8864 12.9382,9.6034 13.0252,9.3414 C13.1142,9.0804 13.3982,8.9404 13.6582,9.0254 Z M21.5,18 C21.776,18 22,18.224 22,18.5 C22,18.776 21.776,19 21.5,19 L2.5,19 C2.224,19 2,18.776 2,18.5 C2,18.224 2.224,18 2.5,18 L21.5,18 Z M12,5 C11.725,5 11.5,5.225 11.5,5.5 C11.5,5.775 11.725,6 12,6 C12.275,6 12.5,5.775 12.5,5.5 C12.5,5.225 12.275,5 12,5 Z M3.5,17 C3.224,17 3,16.776 3,16.5 C3,11.352 6.696,7.293 11.5,7.025 L11.5,6.908 C10.919,6.701 10.5,6.151 10.5,5.5 C10.5,4.673 11.173,4 12,4 C12.827,4 13.5,4.673 13.5,5.5 C13.5,6.151 13.081,6.701 12.5,6.908 L12.5,7.025 C17.304,7.293 21,11.352 21,16.5 C21,16.776 20.776,17 20.5,17 C20.224,17 20,16.776 20,16.5 C20,11.654 16.561,8 12,8 C7.439,8 4,11.654 4,16.5 C4,16.776 3.776,17 3.5,17 Z" }))); };
exports.IconGastronomyThematic = IconGastronomyThematic;
exports.IconGastronomyThematic.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconGastronomyThematic;
